package pl.mothdigital.neuronowi.components.text

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.breakpoint.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.theme.*
import pl.mothdigital.neuronowi.theme.text.*

val PStyle = TextBaseStyle.extendedBy {
    base {
        Modifier
            .fontSize(16.px)
            .lineHeight(26.px)
            .fontWeight(FontWeight.Normal)
            .margin(topBottom = 0.5.cssRem)
    }
    until(Breakpoint.MD) {
        Modifier
            .fontSize(15.px)
            .lineHeight(24.px)
    }
    until(Breakpoint.SM) {
        Modifier
            .fontSize(14.px)
            .lineHeight(22.px)
    }
}


@Composable
fun AppP(
    modifier: Modifier = Modifier,
    color: Color = SiteTheme.black._900,
    content: @Composable () -> Unit = {},
) {
    P(PStyle.toModifier().color(color).margin(0.px).then(modifier).toAttrs()) { content() }
}
